import * as React from 'react';

import { cn } from '@/shared/utils/utils';

interface ToggleProps
  extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'onChange'> {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
}

function Toggle({
  checked = false,
  onChange,
  className,
  onClick,
  ...props
}: ToggleProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      onClick={(e) => {
        onClick?.(e);
        if (!e.defaultPrevented) {
          onChange?.(!checked);
        }
      }}
      className={cn(
        'relative inline-flex h-5 w-9 shrink-0 cursor-pointer rounded-full transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
        checked ? 'bg-[#5E6AD2]' : 'bg-[#d4cdc3]',
        className
      )}
      {...props}
    >
      <span
        className={cn(
          'pointer-events-none block h-4 w-4 rounded-full bg-white shadow-sm ring-0 transition-transform duration-200 translate-y-0.5',
          checked
            ? 'translate-x-[18px] rtl:-translate-x-[18px]'
            : 'translate-x-0.5 rtl:-translate-x-0.5'
        )}
      />
    </button>
  );
}

export { Toggle };
export type { ToggleProps };
